class SingleRecommendationPlacement extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    const variantId =
      this.getAttribute("variant-id") === ""
        ? null
        : this.getAttribute("variant-id")
    const productId = this.getAttribute("product-id")
    const imageUrl =
      this.getAttribute("image-url") === ""
        ? null
        : this.getAttribute("image-url")
    const productsData = JSON.parse(
      document.querySelector("#single-product-recommendations").innerHTML
    )
    let productInfo = null

    if (productId) {
      productInfo = productsData.find((product) => product.id == productId)
    }

    const template = document
      .querySelector("#single-recommendation")
      .content.cloneNode(true)

    let price
    if (productInfo) {
      price = formatMoney(productInfo?.price, "${{amount_no_decimals}}")
    } else {
      if (Shopify.country === "AU") {
        price = this.getAttribute("product-cost-au")
      } else if (Shopify.country === "US") {
        price = this.getAttribute("product-cost-us")
      } else {
        price = this.getAttribute("product-cost")
      }
    }

    template.querySelector("[data-product-image]").src =
      imageUrl ?? productInfo?.featured_image
    template.querySelector("[data-product-title").innerText =
      productInfo?.title ?? this.getAttribute("product-title")
    template.querySelector("[data-product-price]").innerText = price

    let targetAvailable
    if (productInfo) {
      template
        .querySelector("product-card")
        .setAttribute(
          "data-product-card-selected_variant_id",
          variantId ?? productInfo.variants[0]?.id ?? ""
        )

      targetAvailable = variantId
        ? productInfo.variants.filter((variant) => variant.id == variantId)[0]
          .available
        : productInfo?.variants[0].available
    }
    if (!targetAvailable || !productInfo) {
      const submitButton = template.querySelector("product-card button")
      if (productInfo) submitButton.setAttribute("disabled", "disabled")
      submitButton.innerText = !productInfo ? "Join Waitlist" : "Out of Stock"
      submitButton.type = "none"
    }

    if (productInfo)
      template.querySelector(".ProductData").innerHTML =
        JSON.stringify(productInfo)

    this.appendChild(template)

    if (!productInfo) {
      this.querySelector("button").setAttribute("type", "popup-trigger")
      this.querySelector("popup-trigger").runSetup()
    }
  }

  updatePopup() {
    const newTitle = document.querySelector("[popup-title]").innerText
    document.querySelector("[popup-title]").innerText = newTitle.replace(
      "$_product_$",
      this.getAttribute("product-title")
    )
    document.querySelector('input[name="productId"]').value =
      this.getAttribute("product-id")
    document.querySelector('input[name="productName"]').value =
      this.getAttribute("product-title")
  }
}

class MultipleRecommendationPlacement extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    const title = this.getAttribute("title") ?? "Recommendations"

    const products = JSON.parse(
      document.querySelector("#product-recommendations").innerHTML
    )
    const template = document
      .querySelector("#multiple-recommendation")
      .content.cloneNode(true)

    template.querySelector("[data-title]").innerText = title

    this.appendChild(template)
  }

  updatePopup(title, id) {
    const newTitle = document.querySelector("[popup-title]").innerText
    document.querySelector("[popup-title]").innerText = newTitle.replace(
      "$_product_$",
      title
    )
    document.querySelector('input[name="productId"]').value = id
    document.querySelector('input[name="productName"]').value = title
  }
}

customElements.define(
  "single-recommendation-placement",
  SingleRecommendationPlacement
)
customElements.define(
  "multiple-recommendation-placement",
  MultipleRecommendationPlacement
)

class CTABannerPlacement extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    const template = document
      .querySelector("#cta-banner")
      .content.cloneNode(true)
    this.appendChild(template)

    this.querySelector("img").src = this.getAttribute("image-url") || ""
    this.querySelector("[cta-title]").innerText = this.getAttribute("title") || ""
    this.querySelectorAll("[cta-link").forEach((link) => {
      link.href = this.getAttribute("promo-link") || "#"
      link.innerText = this.getAttribute("promo-label") || "Learn More"
    })
  }

}

customElements.define("cta-banner-placement", CTABannerPlacement)

class ProductBannerPlacement extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    const template = document
      .querySelector("#product-banner")
      .content.cloneNode(true)
    
    template.querySelector("shopify-context").setAttribute("handle", this.getAttribute("product-handle") || "frankie");
    this.appendChild(template)
  }
}

class StoreFrontATCHelper extends HTMLElement {
  constructor() {
    super()
  }


  connectedCallback() {
    this.template = this.closest("shopify-context").querySelector("#atc-component").content.cloneNode(true);

    this.atcTrigger = this.template.querySelector("[add-to-cart]")

    const mutationObserver = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'handle' && this.atcTrigger) {
          this.setupATC();
        }
      }
    });

    mutationObserver.observe(this.closest("shopify-context"), { attributes: true });
  }

  setupATC() {
    this.variantId = this.getAttribute("variant-id").split("/").pop();
    const handle = this.closest("shopify-context").getAttribute("handle");

    fetch(`/products/${handle}.js`).then(response => response.ok ? response.json() : null).then(product => {
      this.productData = product;
      if (!product) {
        this.atcTrigger.textContent = "JOIN WAITLIST";
        this.atcTrigger.type = "popup-trigger";
        this.appendChild(this.template);
        this.updatePopup()
        this.querySelector("popup-trigger").runSetup();
        return;
      }
      this.template.querySelector(".ProductData").innerHTML = JSON.stringify(product);
      this.template.querySelector("product-card").setAttribute("data-product-card-selected_variant_id", this.variantId);
      this.appendChild(this.template);
    });
  }

  updatePopup() {
    const newTitle = document.querySelector("[popup-title]").innerText
    document.querySelector("[popup-title]").innerText = newTitle.replace(
      "$_product_$",
      this.getAttribute("product-title")
    )
    document.querySelector('input[name="productId"]').value =
      this.getAttribute("product-id")
    document.querySelector('input[name="productName"]').value =
      this.getAttribute("product-title")
  }
}

customElements.define("storefront-atc-helper", StoreFrontATCHelper);

class CollectionBannerPlacement extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    const template = document
      .querySelector("#collection-banner")
      .content.cloneNode(true)
    this.appendChild(template)

    this.querySelector("img").src = this.getAttribute("image-url") || ""
    this.querySelector("[cta-title]").innerText = this.getAttribute("title") || ""
    this.querySelector("[cta-subtitle]").innerText = this.getAttribute("subtitle") || ""
    this.querySelectorAll("[cta-link").forEach((link) => {
      link.href = this.getAttribute("promo-link") || "#"
      link.innerText = this.getAttribute("promo-label") || "Learn More"
    })
  }

}

customElements.define("collection-banner-placement", CollectionBannerPlacement)
customElements.define("product-banner-placement", ProductBannerPlacement)

const PLACEMENT_TAGS = [
  "single-recommendation-placement",
  "multiple-recommendation-placement",
  "cta-banner-placement",
  "collection-banner-placement",
  "product-banner-placement",
]

function upgradeDataPlacements() {
  PLACEMENT_TAGS.forEach((tag) => {
    document.querySelectorAll(`[data-${tag}]`).forEach((source) => {
      const placement = document.createElement(tag)
      for (const { name, value } of source.attributes) {
        if (name === `data-${tag}`) continue
        if (name.startsWith("data-")) placement.setAttribute(name.slice(5), value)
        else if (name === "class" || name === "style")
          placement.setAttribute(name, value)
      }
      source.replaceWith(placement)
    })
  })
}

document.addEventListener("DOMContentLoaded", () => {
  upgradeDataPlacements()

  const singlePlacements = document.querySelectorAll("[data-single-placement]")
  const multiplePlacements = document.querySelectorAll(
    "[data-multiple-placement]"
  )

  singlePlacements.forEach((placement) => {
    const instance = new SingleRecommendationPlacement()
    instance.setAttribute(
      "variant-id",
      placement.getAttribute("data-variant-id") || ""
    )
    instance.setAttribute(
      "product-id",
      placement.getAttribute("data-product-id") || ""
    )
    instance.setAttribute(
      "image-url",
      placement.getAttribute("data-image-url") || ""
    )
    instance.setAttribute(
      "product-title",
      placement.getAttribute("data-product-title") || ""
    )
    instance.setAttribute(
      "product-cost",
      placement.getAttribute("data-product-cost") || ""
    )
    instance.setAttribute(
      "limited-product",
      placement.getAttribute("data-limited-product") || ""
    )

    // Drops any label text the editor needed to keep the div
    placement.replaceChildren(instance)
  })

  multiplePlacements.forEach((placement) => {
    const instance = new MultipleRecommendationPlacement()
    instance.setAttribute(
      "title",
      placement.getAttribute("data-title") || "Recommendations"
    )
    placement.replaceChildren(instance)
  })
})
